import moment from "moment";
import { httpRequest_002 } from "../../Server/Axios";

export const summaryGridColumn = [
  { field: "A_Id", headerName: "ID", flex: 0.5 },
  {
    field: "A_Date",
    headerName: "Date",
    flex: 1,
    valueFormatter: ({ value }) =>
      value == null ? "" : moment(value).format("DD/MM/YYYY"),
  },
  { field: "A_LocName", headerName: "Location", flex: 1.5 },
  { field: "A_Narr", headerName: "Narration", flex: 2 },
  { field: "A_Status", headerName: "Status", flex: 0.8 },
  { field: "A_Confirm_Status", headerName: "ConfrimStatus", flex: 1 },
  { field: "A_EnBy", headerName: "Entered By", flex: 1.5 },
  {
    field: "A_EnDt",
    headerName: "Entry Date",
    flex: 1,
    valueFormatter: ({ value }) =>
      value == null ? "" : moment(value).format("DD/MM/YYYY"),
  },
  { field: "A_EdBy", headerName: "A_EdBy", flex: 1.5, hide: true },
  {
    field: "A_EdDt",
    headerName: "A_EdDt",
    flex: 1,
    valueFormatter: ({ value }) =>
      value == null ? "" : moment(value).format("DD/MM/YYYY"),
    hide: true,
  },
  { field: "A_ApBy", headerName: "Approved By", flex: 1.5 },
  {
    field: "A_ApDt",
    headerName: "Approved Date",
    flex: 1,
    valueFormatter: ({ value }) =>
      value == null ? "" : moment(value).format("DD/MM/YYYY"),
  },
];

export const sDetailGridColumn = [
  { field: "B_Id", headerName: "ID", flex: 0.5, hide: true },
  { field: "B_Barcode", headerName: "Barcode", flex: 1 },
  { field: "B_ItemName", headerName: "Item Name", flex: 2 },
  { field: "B_ItemNameFL", headerName: "Item Name FL", flex: 2 },
  { field: "B_Category", headerName: "Category Code", flex: 0.8, hide: true },
  { field: "CategoryName", headerName: "Category", flex: 1 },
  {
    field: "B_SubCategory",
    headerName: "SubCategory Code",
    flex: 0.7,
    hide: true,
  },
  { field: "SubCategoryName", headerName: "SubCategory", flex: 1 },
  {
    field: "B_MainCategory",
    headerName: "MainCategory Code",
    flex: 0.7,
    hide: true,
  },
  { field: "MainCategoryName", headerName: "MainCategory", flex: 1 },
  { field: "B_Brand", headerName: "Brand Code", flex: 0.8, hide: true },
  { field: "BrandName", headerName: "Brand", flex: 1 },
  { field: "B_Vendor", headerName: "Vendor Code", flex: 0.8, hide: true },
  { field: "VendorName", headerName: "Vendor", flex: 1.5 },
  { field: "Tax_Name", headerName: "Tax Dept", flex: 1 },
  { field: "B_Packing", headerName: "Packing", flex: 0.8 },
  { field: "B_CostPr", headerName: "Cost Price", flex: 0.7 },
  { field: "B_RSP", headerName: "RSP", flex: 0.8 },
  { field: "B_Vat_RSP", headerName: "VAT RSP", flex: 0.8 },
  {
    field: "B_Narration",
    headerName: "Rejection Narration",
    flex: 2,
    hide: true,
  },
  {
    field: "B_Rejection_reasonName",
    headerName: "Rejection Reason",
    flex: 2,
    hide: true,
  },
];

export const ITEMSREQASummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQASummary`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQLoadAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQLoad`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ItemRequestFieldSearchAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ItemRequestFieldSearch`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQDeleteAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQDelete`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQSaveAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQSave`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};

export const ITEMSREQPostAPI = async (apiObj) => {
  let apiMethod = {
    method: "POST",
    url: `/inventory/physicalstock/ITEMSREQPost`,
    data: apiObj,
  };
  var Data = await httpRequest_002(apiMethod);
  return Data;
};
